import script from "./CalendarView.vue?vue&type=script&setup=true&lang=ts"
export * from "./CalendarView.vue?vue&type=script&setup=true&lang=ts"

import "./CalendarView.vue?vue&type=style&index=0&id=3e408be6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e408be6"]])

export default __exports__